import { Helpers } from "../helpers/helpers";

interface BrainsProps {
    difficulty: number;
}

const brainStyle = {
    height: "20px",
    width: "20px",
}

export const Brains = (props: BrainsProps) => {

    const getNumBrains = (difficulty: number) => Math.floor(difficulty / 20);

    return (
        <>
            {
                Helpers.range(0, getNumBrains(props.difficulty)).map(n => <img
                    src={`${process.env.PUBLIC_URL}/brain.png`}
                    key={n}
                    title={`difficulty ${props.difficulty}%`}
                    style={brainStyle} />
                )
            }
        </>
    )
}